import React from "react";
import { useAccount, useMsal } from "@azure/msal-react";
import { DefaultButton } from "@fluentui/react";
import { interactiveLoginRequest } from "../../auth/authClient";

const AccessDenied = () => {
  const { instance, accounts } = useMsal();
  // Prefer the explicitly active account over accounts[0], which isn't guaranteed to be the
  // one actually used for the current session when multiple accounts are cached.
  const activeAccount = instance.getActiveAccount() ?? accounts[0];
  const account = useAccount(activeAccount ?? undefined);

  // If this was reached silently signed in as the wrong AAD account (e.g. a stale cached
  // session), let the user pick the correct one without needing a separate browser/incognito.
  const switchAccount = () => instance.loginRedirect(interactiveLoginRequest);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Access denied</h2>
      <p>You do not have permission to view this section.</p>
      {account && (
        <p>
          Currently signed in as <strong>{account.username}</strong>. If your
          access was recently granted or changed, reauthenticating can
          refresh your permissions.
        </p>
      )}
      <DefaultButton onClick={switchAccount}>
        Reauthenticate / sign in with another account
      </DefaultButton>
    </div>
  );
};

AccessDenied.displayName = AccessDenied.name;

export default AccessDenied;
